import { Menu as SemanticMenu } from 'semantic-ui-react';

export { MenuProps, StrictMenuProps } from 'semantic-ui-react';

export const Menu: typeof SemanticMenu = SemanticMenu;

export default Menu;
